/* RESPONSIBLE TEAM: team-automation-foundations */
import AutomationFinAIAgentContentFolderController from 'embercom/controllers/apps/app/automation/fin-ai-agent/content-folder';

export default class AutomationFinAIAgentSalesContentFolderController extends AutomationFinAIAgentContentFolderController {}
